export default {
  achievementtop:
    "https://pxboss.xiaohebang.cn/system/material/parent/main/achievement-detail-bg-top.png",
  avatarDefault:
    "https://pxboss.xiaohebang.cn/system/material/parent/main/avatarDefault.png",
  bg: "https://pxboss.xiaohebang.cn/system/material/parent/main/bg.png",
  boy: "https://pxboss.xiaohebang.cn/system/material/parent/main/boy.png",
  call: "https://pxboss.xiaohebang.cn/system/material/parent/main/call.gif",
  commentico:
    "https://pxboss.xiaohebang.cn/system/material/parent/main/comment-icon.png",
  Crown: "https://pxboss.xiaohebang.cn/system/material/parent/main/Crown.png",
  default:
    "https://pxboss.xiaohebang.cn/system/material/parent/main/default.jpg",
  defaultKc:
    "https://pxboss.xiaohebang.cn/system/material/parent/main/defaultKc.png",
  down: "https://pxboss.xiaohebang.cn/system/material/parent/main/down.png",
  empty: "https://pxboss.xiaohebang.cn/system/material/parent/main/empty.png",
  gift: "https://pxboss.xiaohebang.cn/system/material/parent/main/gift.png",
  girl: "https://pxboss.xiaohebang.cn/system/material/parent/main/girl.png",
  guide: "https://pxboss.xiaohebang.cn/system/material/parent/main/guide.png",
  map: "https://pxboss.xiaohebang.cn/system/material/parent/main/map.png",
  onAddress:
    "https://pxboss.xiaohebang.cn/system/material/parent/main/onAddress.png",
  out: "https://pxboss.xiaohebang.cn/system/material/parent/main/out.png",
  register:
    "https://pxboss.xiaohebang.cn/system/material/parent/main/register.jpg",
  shareicon:
    "https://pxboss.xiaohebang.cn/system/material/parent/main/share-icon.png",
  status1:
    "https://pxboss.xiaohebang.cn/system/material/parent/main/status1.jpg",
  status2:
    "https://pxboss.xiaohebang.cn/system/material/parent/main/status2.jpg",
  status3:
    "https://pxboss.xiaohebang.cn/system/material/parent/main/status3.jpg",
  tryClass:
    "https://pxboss.xiaohebang.cn/system/material/parent/main/tryClass.gif",
  tx: "https://pxboss.xiaohebang.cn/system/material/parent/main/tx.jpg",
  unbindStudent:
    "https://pxboss.xiaohebang.cn/system/material/parent/main/unbindStudent.png",
  visitorLogin:
    "https://pxboss.xiaohebang.cn/system/material/parent/main/visitorLogin.png",
  videoPlay:
    "https://pxboss.xiaohebang.cn/system/material/parent/main/media/videoPlay.png",
  voicePlay:
    "https://pxboss.xiaohebang.cn/system/material/parent/main/media/voicePlay.png",
  loginbg:
    "https://pxboss.xiaohebang.cn/system/material/parent/main/loginbg.png",
  xiaohebang:
    "https://pxboss.xiaohebang.cn/system/material/parent/xiaohebang.png",
  xiaohebang2:
    "https://pxboss.xiaohebang.cn/system/material/parent/xiaohebang2.png",
  sysName: "小禾帮",

  homeBg: "https://pxboss.xiaohebang.cn/system/material/parent/new/homeBg.png",
  tab_sy: "https://pxboss.xiaohebang.cn/system/material/parent/new/tab_sy.png",
  tab_sy_a:
    "https://pxboss.xiaohebang.cn/system/material/parent/new/tab_sy_a.png",
  tab_wd: "https://pxboss.xiaohebang.cn/system/material/parent/new/tab_wd.png",
  tab_wd_a:
    "https://pxboss.xiaohebang.cn/system/material/parent/new/tab_wd_a.png",
  tab_cz: "https://pxboss.xiaohebang.cn/system/material/parent/new/tab_cz.png",
  tab_cz_a:
    "https://pxboss.xiaohebang.cn/system/material/parent/new/tab_cz_a.png",

  growBg: "https://pxboss.xiaohebang.cn/system/material/parent/new/growBg.png",

  fx: "https://pxboss.xiaohebang.cn/system/material/parent/new/fx.png",
  sc: "https://pxboss.xiaohebang.cn/system/material/parent/new/sc.png",
  pl: "https://pxboss.xiaohebang.cn/system/material/parent/new/pl.png",
  dz: "https://pxboss.xiaohebang.cn/system/material/parent/new/dz.png",

  sc_a: "https://pxboss.xiaohebang.cn/system/material/parent/new/sc_a.png",
  dz_a: "https://pxboss.xiaohebang.cn/system/material/parent/new/dz_a.png",

  myBg: "https://pxboss.xiaohebang.cn/system/material/parent/new/myBg.png",

  contentHeadBg:
    "https://pxboss.xiaohebang.cn/system/front/parent/contentHeadBg.png",
  starLeft:
    "https://pxboss.xiaohebang.cn/system/front/parent/starLeft.png",
  starRight:
    "https://pxboss.xiaohebang.cn/system/front/parent/starRight.png",
    iconHome:
    "https://pxboss.xiaohebang.cn/system/front/parent/icon-home.png",
    iconTel:
    "https://pxboss.xiaohebang.cn/system/front/parent/icon-tel.png",
    iconLocaltion:
    "https://pxboss.xiaohebang.cn/system/front/parent/icon-localtion.png",
    rightIcon:'https://pxboss.xiaohebang.cn/system/front/parent/rightIcon.png',
    growHead:"https://pxboss.xiaohebang.cn/system/front/parent/weixin.png"
};



// WEBPACK FOOTER //
// ./src/api/img.js